import { GA4EventActionEnum } from './GA4TrackerType';

export enum GalleryEvents {
    Gallery = 'gallery',
    PhotoOpen = 'photo_open',
    Photo = 'photo',
    Carousel = 'carousel',
    PlayVideo = 'playVideo',
    GalleryViewExpanded = 'galleryViewExpanded',
}

export enum GalleryEventsName {
    Carousel = 'Carousel',
    GalleryOpened = 'Gallery Opened',
    GalleryViewExpanded = 'Gallery View Expanded',
    PlayVideo = 'Play Video',
}

export enum ListingEvents {
    PageLoad = 'pageview',
    PageViewLDP = 'pageviewLDP',
    Shares = 'Shares',
    Saved = 'Saved',
    Enquiry = 'enquiry',
    ListingImpression = 'listingImpression',
    SectionImpressed = 'sectionImpressed',
    SectionIconClicked = 'sectionIconClicked',
    ListingClick = 'listingClick',
    ActionClick = 'actionClick',
    OTPUnverified = 'otpUnverified',
    OTPFormSubmitted = 'otpFormSubmitted',
    OTPNumberSubmitted = 'otpNumberSubmitted',
    PostEnquiryPopUpImpressions = 'postEnquiryPopUpImpressions',
    BypassOTP = 'bypassOTP',
    DownloadMobileAppBannerClick = 'downloadMobileAppBannerClick',
    DownloadMobileAppBannerImpressions = 'downloadMobileAppBannerImpressions',
    LDPCalculatorDetailClicked = 'ldpCalculatorDetailClicked',
    MortgageSimulationUpdateDP = 'mortgageSimulationUpdateDP',
    ListingReportSubmission = 'listingReportSubmission',
    ReportButtonClicks = 'reportButtonClicks',
    ReportButtonImpressions = 'reportButtonImpressions',
    MortgageListingEnquiryImpression = 'mortgageListingEnquiryImpression',
    MortgageListingEnquirySubmit = 'mortgageListingEnquirySubmit',
    ResendOTP = 'resendOTP',
    CoBrokeEnquiryClicked = 'coBrokeEnquiryClicked',
    CoMarketingClicked = 'coMarketingClicked',
    CoMarketingConfirmed = 'coMarketingConfirmed',
    CoMarketingWithdrawal = 'coMarketingWithdrawal',
    FavoriteSectionViewed = 'favoriteSectionViewed',
    Photo = 'photo',
    PlayVideo = 'playVideo',
    Carousel = 'carousel',
    TabClicked = 'tabClicked',
}

export enum Trackers {
    Segment = 'segment',
    GA4Old = 'ga4old',
    GA4New = 'ga4new',
}

type EventMapping = {
    [key: string]: [string, string, string];
};

export const eventMappings: EventMapping = {
    // ['1st index = Segment Mapping', '2nd index = Old GA4 Mapping', '3rd index = New GA4 Mapping']
    pageview: ['', 'pageview', ''],
    pageviewLDP: ['', 'pageview_ajax_pdp', ''],
    gallery: ['Event Action Clicked', 'galleryOpened', 'Gallery'],
    photo_open: ['Event Action Clicked', 'photoDetailOpened', ''],
    photo: ['Event Action Clicked', 'listingMedia', ''],
    tabClicked: ['Tab Clicked', 'listingMedia', ''],
    carousel: ['Event Action Clicked', '', ''],
    playVideo: ['Event Action Clicked', '', ''],
    galleryViewExpanded: ['Event Action Clicked', '', ''],
    Shares: ['Event Action Clicked', '', ''],
    Saved: ['Event Action Clicked', '', ''],
    enquiry: ['Enquiry Clicked', 'listingPhone', GA4EventActionEnum.Enquiry],
    otpUnverified: [
        'Enquiry Clicked',
        'otpEnquiryButtonUnverifiedClick',
        GA4EventActionEnum.OTPUnverifiedClick,
    ],
    bypassOTP: ['Enquiry Clicked', '', ''],
    ldpCalculatorDetailClicked: ['Detail Calculation Clicked', '', ''],
    mortgageSimulationUpdateDP: ['', 'mortgageSimulationUpdateDP', ''],
    listingReportSubmission: ['', 'listingReportSubmission', ''],
    reportButtonClicks: ['', 'reportButtonClicks', ''],
    reportButtonImpressions: ['', 'reportButtonImpressions', ''],
    download: ['', 'reportButtonImpressions', ''],
    downloadMobileAppBannerClick: ['Download Mobile App Banner Click', '', ''],
    downloadMobileAppBannerImpressions: [
        'Download Mobile App Banner Impressed',
        '',
        '',
    ],
    otpFormSubmitted: [
        '',
        'otpFormSubmission',
        GA4EventActionEnum.OTPFormSubmitted,
    ],
    otpNumberSubmitted: [
        '',
        'otpNumberSubmission',
        GA4EventActionEnum.OTPNumberSubmitted,
    ],
    postEnquiryPopUpImpressions: ['', 'postEnquiryPopUpImpressions', ''],
    listingImpression: [
        'Property Impressed',
        '',
        GA4EventActionEnum.ListingImpression,
    ],
    sectionImpressed: ['Section Impressed', '', ''],
    sectionIconClicked: ['Section Icon Clicked', '', ''],
    listingClick: ['Property Clicked', '', GA4EventActionEnum.ListingClick],
    actionClick: ['Event Action Clicked', '', ''],
    mortgageListingEnquiryImpression: [
        'KPR Listing Enquiry Impression',
        '',
        '',
    ],
    mortgageListingEnquirySubmit: ['KPR Listing Enquiry Submit', '', ''],
    resendOTP: ['', '', GA4EventActionEnum.ResendOTP],
    coBrokeEnquiryClicked: ['Co Broke Enquiry Clicked', '', ''],
    coMarketingClicked: ['Co Marketing Clicked', '', ''],
    coMarketingConfirmed: ['Co Marketing Confirmed', '', ''],
    coMarketingWithdrawal: ['Co Marketing Withdrawal', '', ''],
    favoriteSectionViewed: ['Favorite Section Viewed', '', ''],
    // Add more mappings here
};

export enum EventType {
    Click = 'Event Action Clicked',
    Impression = 'Event Action Impressed',
    Enquiry = 'Enquiry Clicked',
}
